import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { MonitorSuggestApi } from './apis/monitor-suggest-api';
import { MonitorSuggestApiImpl } from './apis/impls/monitor-suggest-api';
import { MonitorSuggestService } from './services/monitor-suggest-service';
import { MonitorSuggestServiceImpl } from './services/impls/monitor-suggest-service';
import { MonitorSuggestRepository } from './services/monitor-suggest-repository';
import { MonitorSuggestRepositoryImpl } from './repositories/impls/monitor-suggest-repository';

export const monitorSuggestContainer = new ContainerModule(bind => {
    bind(MonitorSuggestApi).to(MonitorSuggestApiImpl);
    bind(MonitorSuggestRepository).to(MonitorSuggestRepositoryImpl);
    bind(MonitorSuggestService).to(MonitorSuggestServiceImpl);
});
